import SecurityContext from '@/modules/common/services/security-context.service'
import { Container } from 'typedi'
import { AccessLevel } from '@/modules/common/enums/access-levels.enum'

const hasRoles = (roles: any[]|any) => {
  const userRoles: any = Container.get(SecurityContext).accessLevel()
  const requiredRoles: any [] = Array.isArray(roles) ? roles : [roles]
  return userRoles === AccessLevel.DEVELOPER ? true : requiredRoles.includes(userRoles)
}

export default hasRoles
